/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取我的印花活动列表
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class MyPrintingListParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: MyPrintingListParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.JoinPrintingActivityListResponse>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/joinPrintingList`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
